import { render } from "./ProductSearch.vue?vue&type=template&id=572832f8&scoped=true"
import script from "./ProductSearch.vue?vue&type=script&lang=js"
export * from "./ProductSearch.vue?vue&type=script&lang=js"

import "@/assets/style/table.css?vue&type=style&index=0&lang=css"
import "./ProductSearch.vue?vue&type=style&index=1&id=572832f8&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-572832f8"]])

export default __exports__